(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ankuendigungsleiste"] && !Shopify.designMode) return;
  try {
    
/* Swiper gibt es nur noch im Versandpause-Zweig — ohne Element nicht initialisieren */
if (document.querySelector('.mySwiper .swiper-slide')) {
  var swiper = new Swiper(".mySwiper", {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      }
  });
}

  } catch(e) { console.error(e); }
})();
})();
